import React, { useRef } from "react";
import useModal from "./useModal";

export default function ConfirmDialog({
  open,
  title,
  children,
  confirmLabel,
  busyLabel,
  busy,
  onConfirm,
  onCancel,
}) {
  const ref = useRef(null);
  useModal(open, busy ? () => {} : onCancel, ref);

  if (!open) return null;

  return (
    <div className="adm-dialog-wrap">
      <div className="adm-overlay" onClick={busy ? undefined : onCancel} />
      <div
        ref={ref}
        className="adm-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="adm-confirm-title"
        tabIndex={-1}
      >
        <h3 id="adm-confirm-title" className="adm-dialog__title">
          {title}
        </h3>
        <div className="adm-dialog__body">{children}</div>
        <div className="adm-dialog__actions">
          <button
            type="button"
            className="adm-btn adm-btn--secondary"
            onClick={onCancel}
            disabled={busy}
            data-autofocus
          >
            Cancel
          </button>
          <button
            type="button"
            className="adm-btn adm-btn--danger"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? busyLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
